"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EffectRe = /\x1b\[\?((?:\d+)(?:[hl]))/;
var EffectTable = {
    '25h': { name: 'cursorOn' },
    '25l': { name: 'cursorOff' },
    '1049h': { name: 'altScrBufOn' },
    '1049l': { name: 'altScrBufOff' },
    '2004h': { name: 'bracketedPasteOn' },
    '2004l': { name: 'bracketedPasteOff' }
};
var process = function (str) {
    var matched = str.match(EffectRe);
    var result = [];
    if (matched) {
        if (matched.index > 0) {
            result.push(['text', str.slice(0, matched.index)]);
        }
        var key = matched[1];
        var codeDef = EffectTable[key];
        if (codeDef) {
            result.push([codeDef.name]);
        }
        else {
            result.push(['unknown', key]);
        }
    }
    var left = matched ? str.slice(matched.index + matched[0].length) : str;
    return { result: result, left: left };
};
exports.default = process;
//# sourceMappingURL=effect-code.js.map